import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '../base-component';
import VueRecaptcha from 'vue-recaptcha';
import { PageDTO } from '@/model/PageDTO';

import { range } from 'lodash-es';
import Bowser from 'bowser';

interface FormValues {
	name: string;
	email: string;
	phone: string;
	message: string;
	news: boolean;
	gdpr: boolean;
}

interface FormErrors {
	nameEmpty: boolean;
	emailEmpty: boolean;
	emailNotValid: boolean;
	phoneEmpty: boolean;
	gdprEmpty: boolean;
	recaptchaNotVerified: boolean;
	submitFailed: boolean;
}

@Component({
	components: { 'vue-recaptcha': VueRecaptcha }
})
export class ReservationForm extends BaseComponent {

	formValues: FormValues = null;
	errors: FormErrors = null;

	recaptchaResponse: string = null;
	success: boolean = false;
	gdprInformation: string = null;

	created() {
		this.reset();
	}

	verifyCaptcha(response: string) {
		this.recaptchaResponse = response;
	}

	async submit(e: Event) {
		e.preventDefault();

		if (this.isValid()) {
			// gtm dataLayer.push to track form sending - see function gtm() in WMS2 CKontaktniFormularPopup
			const leadId = this.randomString(12);
			(window as any).dataLayer = (window as any).dataLayer || [];
			(window as any).dataLayer.push({
				'event': 'leadFormSent',
				'leadFormSentData': this.gtmLeadData(leadId),
				'eventCallback': function () {
					(window as any).dataLayer.push({ 'leadFormSentData': undefined });
				}
			})


			const bowser = Bowser.parse(window.navigator.userAgent)
			const gdprInformation = "" + this.$store.timeId + "," + this.$store.langId + "," + bowser.browser.name.toString() + "," + bowser.browser.version.toString() + "," + bowser.os.name.toString() + "," + bowser.os.version.toString() + "";

			// prepare mail contents
			const mailTo = this.getText('email-recipient-address');
			const mailToClient = this.formValues.email;

			const messageHeader = `
				leadId: ${leadId}<br /><br />
				${this.getText('email-intro-text')}
				- page = ${this.$route.fullPath}<br />
				- jv = ${this.$store.langId}<br /><br />
				${this.getText('form-input-name')}: ${this.htmlEncode(this.formValues.name)}<br /><br />
				${this.getText('form-input-email')}: ${mailToClient}<br /><br />
				${this.getText('form-input-phone')}: ${this.htmlEncode(this.formValues.phone)}<br /><br />
				${this.getText('form-input-message')}:<br />
			`;

			const messageItself = this.htmlEncode(this.formValues.message);

			const emailNewsChoice = `<b>${this.getText(this.formValues.news ? 'email-news-consent' : 'email-news-disconsent')}</b><br />`;
			const gdprChoice = this.formValues.gdpr ? `<b>${this.getText('email-gdpr-consent')}</b><br />` : '';
			const messageFooter = `
				<br /><br /><br />
				${emailNewsChoice}
				${gdprChoice}
			`;

			// send mail using mail service
			try {
				await this.$mailService.sendReservationMail({
					mailTo,
					mailToClient,
					messageHeader,
					messageItself,
					messageFooter,
					recaptchaResponse: this.recaptchaResponse,
					gdprInformation

				});

				this.success = true;
			} catch (e) {
				this.errors.submitFailed = true;
			}
		}
	}

	isValid() {
		Object.keys(this.errors).forEach((k: keyof FormErrors) => this.errors[k] = false);

		if (!this.formValues.name) {
			this.errors.nameEmpty = true;
		}

		if (!this.formValues.email) {
			this.errors.emailEmpty = true;
		}
		else if (!this.isValidEmail(this.formValues.email)) {
			this.errors.emailNotValid = true;
		}
		/*
		if (!this.formValues.phone) {
			this.errors.phoneEmpty = true;
		}
		*/
		if (!this.formValues.gdpr) {
			this.errors.gdprEmpty = true;
		}

		if (!this.recaptchaResponse) {
			this.errors.recaptchaNotVerified = true;
		}

		return Object.keys(this.errors).every((k: keyof FormErrors) => !this.errors[k]);
	}

	isValidEmail(email: string) {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	reset() {
		this.formValues = {
			name: '',
			email: '',
			phone: '',
			message: '',
			news: false,
			gdpr: false
		};

		this.errors = {
			nameEmpty: false,
			emailEmpty: false,
			emailNotValid: false,
			phoneEmpty: false,
			gdprEmpty: false,
			recaptchaNotVerified: false,
			submitFailed: false
		};

		this.success = false;
	}

	randomString(length: number) {
		const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
		return range(length).map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
	}

	gtmLeadData(leadId: string) {
		let data: any = {};

		data.leadId = leadId;

		let locationId = null;
		let price = null;

		if (this.$store.pageData.apartment) {
			locationId = this.$store.pageData.apartment.location.id;
			price = this.$store.pageData.apartment.totalPriceWithVAT;
		}
		else if (this.$store.pageData.location) {
			locationId = this.$store.pageData.location.id;
		}

		if (locationId) {
			data.locationId = locationId.toString();
		}
		if (price) {
			data.price = price;
		}

		return data;
	}

	htmlEncode(text: string) {
		const auxDiv = document.createElement("div");
		auxDiv.innerText = text;
		return auxDiv.innerHTML;
	}
}

export default ReservationForm;
